export default {
  trigger: 'Restaurantinhaber einladen',
  title: 'Restaurantinhaber einladen',
  description:
    'Erstelle ein Konto für den Restaurantinhaber. Er erhält eine E-Mail mit einem temporären Passwort, um sich anzumelden und die Einrichtung des Restaurants abzuschließen.',
  fields: {
    first_name: 'Vorname',
    last_name: 'Nachname',
    email: 'E-Mail',
  },
  buttons: {
    invite: 'Einladung senden',
    cancel: 'Abbrechen',
  },
  toasts: {
    invited: '{{email}} wurde eingeladen, die Einrichtung abzuschließen.',
    failed: 'Das Inhaberkonto konnte nicht erstellt werden. Bitte versuche es erneut.',
  },
};
